import { KeycloakConfig } from "keycloak-js";
import { Config } from "../../config";

export function getKeClientId(config: Config) {
    const keycloakConfig = config.identityProvider.keycloakConfig as KeycloakConfig;
    const keConfig = config.pipeline;

    return keConfig?.keycloakEffectiveClientId || keycloakConfig.clientId;
}